import { v4 as uuid } from 'uuid';
import { HourMinute } from './hour-minute';

export class Shift {
  public name = '';
  public id: string = uuid();
  public startTime: HourMinute;
  public endTime: HourMinute;

  public static fromDto(shift: any): Shift {
    return {
      name: shift.name,
      id: shift.id,
      startTime: { hour: shift.startTime.hour, minute: shift.startTime.minute },
      endTime: { hour: shift.endTime.hour, minute: shift.endTime.minute }
    };
  }

  constructor(name: string, startTime: HourMinute, endTime: HourMinute) {
    this.name = name;
    this.startTime = startTime;
    this.endTime = endTime;
  }
}
